<template>  
    <div id="profile" class="card card-body mt-4">
      <div class="row justify-content-center align-items-center">        
        <div class="col-sm-auto col-8 my-auto">
          <div class="h-100">
            <h5 class="mb-1 font-weight-bolder">{{ $t('animal.UBN') }}: {{ state.ubn }}</h5>
            <p class="mb-0 font-weight-bold text-sm">
              {{ state.associationName }}
            </p>
          </div>
        </div>
        <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">          
        </div>
      </div>
    </div>    
    <div id="info" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('animal.Animal_info') }}</h5>
        <p class="text-sm">{{ $t('animal.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">        
            <div class="row">              
              <div class="col-4">
                <div class="input-group input-group-static null">
                  <label class="">{{ $t('animal.Tag_number') }} </label>
                  <input v-model="state.tagNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Tag_number')" :disabled="isRestrictedRole">            
                </div>
              </div>
              <div class="col-4">
                  <div class="input-group input-group-static null">
                    <label class="">{{ $t('animal.Country_of_birth') }} *</label>
                    <template v-if="isRestrictedRole">
                      <input type="text" class="form-control form-control-default" :value="state.countryCodes.find(x => x.id === state.countryOfBirthId)?.name || ''" disabled />
                    </template>
                    <template v-else>
                      <select id="countryOfBirthId" v-model="state.countryOfBirthId" class="form-control form-control-default">
                        <option value="">{{ $t('animal.Select_country_of_birth') }}</option>         
                        <option v-for="item in state.countryCodes" :key="item.id" :value="item.id">                  
                            {{ item.name }}
                        </option>
                      </select>
                      <span v-if="vAnimalDetails$.countryOfBirthId.$error" class="text-sm text-danger">
                          {{ vAnimalDetails$.countryOfBirthId.$errors[0].$message }}
                      </span>
                    </template>
                  </div>
                </div>  
            </div>
            <div class="row mt-4">        
              <div class="col-4">
                <div class="input-group input-group-static null">
                  <label class="">{{ $t('animal.Animal_number') }}</label>
                  <input v-model="state.animalNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Animal_number')" :disabled="isRestrictedRole">            
                </div>
              </div>
              <div class="col-4">
                <div class="input-group input-group-static null">
                  <label class="">{{ $t('animal.Studbook_number') }} *</label>
                  <input v-model.lazy.trim="state.studbookNumber" @blur="vAnimalDetails$.studbookNumber.$touch()" type="text" class="form-control form-control-default" :placeholder="$t('animal.Studbook_number')" :disabled="isRestrictedRole">
                  <span v-if="vAnimalDetails$.studbookNumber.$error" class="text-sm text-danger">
                    {{ vAnimalDetails$.studbookNumber.$errors[0]?.$message }}
                  </span>
                </div>
              </div>
              <div class="col-4">
                  <div class="input-group input-group-static null">
                    <label class="">{{ $t('animal.Birth_date') }} *</label>
                    <input v-model="state.birthDate" type="date" class="form-control form-control-default" :placeholder="$t('animal.Birth_date')" :disabled="isRestrictedRole">
                    <span v-if="vAnimalDetails$.birthDate.$error" class="text-sm text-danger">
                        {{ vAnimalDetails$.birthDate.$errors[0].$message }}
                    </span>
                  </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-4">
                <div class="input-group input-group-static null">
                  <label>{{ $t('animal.Gender') }} *</label>
                  <template v-if="isRestrictedRole">
                    <input type="text" class="form-control form-control-default" :value="state.animalGenders.find(x => x.id === state.genderId)?.name || ''" disabled />
                  </template>
                  <template v-else>
                    <select id="genderId" v-model="state.genderId" class="form-control form-control-default">
                        <option value="">{{ $t('animal.Select_gender') }}</option>         
                        <option v-for="item in state.animalGenders" :key="item.id" :value="item.id">                  
                            {{ item.name }}
                        </option>
                    </select>
                    <span v-if="vAnimalDetails$.genderId.$error" class="text-sm text-danger">
                        {{ vAnimalDetails$.genderId.$errors[0].$message }}
                    </span>
                  </template>
                </div>
              </div>
              <div class="col-4">
                <div class="input-group input-group-static null">
                  <label>{{ $t('animal.Breed') }} *</label>
                  <template v-if="isRestrictedRole">
                    <input type="text" class="form-control form-control-default" :value="state.breeds.find(x => x.id === state.breedId)?.name || ''" disabled />
                  </template>
                  <template v-else>  
                    <select id="breedId" v-model="state.breedId" class="form-control form-control-default" :disabled="isRestrictedRole">
                        <option value="">{{ $t('animal.Select_breed') }}</option>
                        <option v-for="item in state.breeds" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                    <span v-if="vAnimalDetails$.breedId.$error" class="text-sm text-danger">
                        {{ vAnimalDetails$.breedId.$errors[0].$message }}
                    </span>
                  </template>
                </div>
              </div>
              <div class="col-4">
                <div class="input-group input-group-static null">
                  <label class="d-block mb-1" style="width: inherit;">{{ $t('animal.Casterated') }}</label>
                  <div class="d-block mt-1">
                    <material-switch v-model="state.casterated" id="casterated" name="casterated" :disabled="isRestrictedRole" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">          
                <div class="col-4">
                  <div class="input-group input-group-static null">
                      <label class="">{{ $t('animal.Name') }}</label>
                      <input v-model="state.name" type="text" class="form-control form-control-default" :placeholder="$t('animal.Name')" :disabled="isRestrictedInsp" :autofocus="isRestrictedKeep">
                  </div>
                </div>  
                <div class="col-4">
                  <div class="input-group input-group-static null">
                    <label>{{ $t('animal.Colour') }}</label> 
                    <template v-if="isRestrictedRole">
                      <input type="text" class="form-control form-control-default" :value="state.animalColours.find(x => x.id === state.colorId)?.name || ''" disabled />
                    </template>
                    <template v-else>
                      <select id="colorId" v-model="state.colorId" class="form-control form-control-default">
                          <option value="">{{ $t('animal.Select_colour') }}</option>         
                          <option v-for="item in state.animalColours" :key="item.id" :value="item.id">                  
                              {{ item.name }}
                          </option>
                      </select>
                    </template>
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-group input-group-static null">
                    <label class="">{{ $t('animal.Inbreed_Factor') }}</label>
                    <input v-model="state.inbreedFactor" type="text" class="form-control form-control-default" :placeholder="$t('animal.Inbreed_Factor')" :disabled="isRestrictedRole">
                    <span v-if="vAnimalDetails$.inbreedFactor.$error" class="text-sm text-danger">
                      {{ vAnimalDetails$.inbreedFactor.$errors[0].$message }}
                    </span>
                  </div>
                </div>      
            </div>
            <div class="row mt-4">
                <div class="col-4">
                  <div class="input-group input-group-static null">
                    <label>{{ $t('animal.Genotype') }}</label>
                    <template v-if="isRestrictedRole">
                      <input type="text" class="form-control form-control-default" :value="state.animalGenoTypes.find(x => x.id === state.genoTypeId)?.name || ''" disabled />
                    </template>
                    <template v-else>
                      <select id="genoTypeId" v-model="state.genoTypeId" class="form-control form-control-default">
                          <option value="">{{ $t('animal.Select_genotype') }}</option>
                          <option v-for="item in state.animalGenoTypes" :key="item.id" :value="item.id">
                              {{ item.name }}
                          </option>
                      </select>
                    </template>
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-group input-group-static null">
                    <label>{{ $t('animal.Genotype2') }}</label> 
                    <template v-if="isRestrictedRole">
                      <input type="text" class="form-control form-control-default" :value="state.animalGenoTypes2.find(x => x.id === state.genoTypeId2)?.name || ''" disabled />
                    </template>
                    <template v-else> 
                      <select id="genoTypeId2" v-model="state.genoTypeId2" class="form-control form-control-default">
                          <option value="">{{ $t('animal.Select_genotype2') }}</option>
                          <option v-for="item in state.animalGenoTypes2" :key="item.id" :value="item.id">
                              {{ item.name }}
                          </option>
                      </select>
                    </template>
                  </div>
                </div>
            </div> 
      
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateAnimalInfo" class="btn btn-sm bg-gradient-success mr-2 float-end" :disabled="vAnimalDetails$.$pending || vAnimalDetails$.$invalid">{{ $t('animal.Update_animal_info') }}</button>
        </div>
      </div>
    </div>
    <div id="arrival" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('animal.Arrival') }}</h5>
        <p class="mb-0 text-sm">{{ $t('animal.Optional_information') }}</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">          
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Date') }}</label>
              <input v-model="state.arrivalDate" type="date" class="form-control form-control-default" :placeholder="$t('animal.Date')" :disabled="isRestrictedRole"> 
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.UBN') }}</label>
              <input v-model="arrivalFromUbnDisplay" type="text" class="form-control form-control-default" :placeholder="$t('animal.UBN')" :disabled="isRestrictedRole">
            </div>
          </div>
      </div>
      <div class="row mt-3">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Origin') }}</label>
              <template v-if="isRestrictedRole">
                <input type="text" class="form-control form-control-default" :value="state.origins.find(x => x.id === state.originId)?.description || ''" disabled />
              </template>
              <template v-else> 
                <select id="originId" v-model="state.originId" class="form-control form-control-default">
                    <option value="">{{ $t('animal.Select_origin') }}</option>         
                    <option v-for="item in state.origins" :key="item.id" :value="item.id">                  
                        {{ item.description }}
                    </option>
                </select>
              </template>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Country') }}</label>
              <template v-if="isRestrictedRole">
                <input type="text" class="form-control form-control-default" :value="state.countryCodes.find(x => x.id === state.countryCodeId)?.name || ''" disabled />
              </template>
              <template v-else>   
                <select id="countryCodeId" v-model="state.countryCodeId" class="form-control form-control-default">
                    <option value="">{{ $t('animal.Select_country') }}</option>
                    <option v-for="item in state.countryCodes" :key="item.id" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
              </template>
            </div>
          </div>      
      </div>
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateArrival" class="btn btn-sm bg-gradient-success mr-2 float-end" v-show="!isRestrictedRole">{{ $t('animal.Update_arrival') }}</button>
        </div>
      </div>
    </div>    
    <div id="pedigree" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('animal.Pedigree') }}</h5>
        <p class="text-sm">{{ $t('animal.Optional_information') }}</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <p class="fw-bold">{{ $t('animal.Father_details') }}</p>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Country') }}</label>
              <template v-if="isRestrictedRole">
                <input type="text" class="form-control form-control-default" :value="state.countryCodes.find(x => x.id === state.fatherCountryCodeId)?.name || ''" disabled />
              </template>
              <template v-else> 
                <select id="fatherCountryCodeId" v-model="state.fatherCountryCodeId" class="form-control form-control-default">
                    <option value="">{{ $t('animal.Select_country') }}</option>
                    <option v-for="item in state.countryCodes" :key="item.id" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
              </template>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Father_tagnumber') }}</label>
              <input v-model="state.fatherTagNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Father_tagnumber')" :disabled="isRestrictedRole"> 
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Father_studbook_number') }}</label>
              <input v-model="state.fatherStudbookNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Father_studbook_number')" :disabled="isRestrictedRole"> 
            </div>
          </div>
        </div>
        <div class="row mt-3">
            <p class="fw-bold">{{ $t('animal.Mother_details') }}</p>
            <div class="col-4">
              <div class="input-group input-group-static null">
                <label>{{ $t('animal.Country') }}</label>
                <template v-if="isRestrictedRole">
                  <input type="text" class="form-control form-control-default" :value="state.countryCodes.find(x => x.id === state.motherCountryCodeId)?.name || ''" disabled />
                </template>
                <template v-else> 
                  <select id="motherCountryCodeId" v-model="state.motherCountryCodeId" class="form-control form-control-default">
                      <option value="">{{ $t('animal.Select_country') }}</option>
                      <option v-for="item in state.countryCodes" :key="item.id" :value="item.id">
                          {{ item.name }}
                      </option>
                  </select>
                </template>
              </div>
            </div>
            <div class="col-4">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('animal.Mother_tagnumber') }}</label>
                <input v-model="state.motherTagNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Mother_tagnumber')" :disabled="isRestrictedRole"> 
              </div>
            </div>
            <div class="col-4">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('animal.Mother_studbook_number') }}</label>
                <input v-model="state.motherStudbookNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Mother_studbook_number')" :disabled="isRestrictedRole"> 
              </div>
            </div>
        </div>
        <div class="row mt-3">
            <p class="fw-bold">{{ $t('animal.Receipent_mother') }}</p>
            <div class="col-4">
              <div class="input-group input-group-static null">
                <label>{{ $t('animal.Country') }}</label>
                <template v-if="isRestrictedRole">
                  <input type="text" class="form-control form-control-default" :value="state.countryCodes.find(x => x.id === state.receipientMotherCountryCodeId)?.name || ''" disabled />
                </template>
                <template v-else> 
                  <select id="receipientMotherCountryCodeId" v-model="state.receipientMotherCountryCodeId" class="form-control form-control-default">
                      <option value="">{{ $t('animal.Select_country') }}</option>
                      <option v-for="item in state.countryCodes" :key="item.id" :value="item.id">
                          {{ item.name }}
                      </option>
                  </select>
                </template>
              </div>
            </div>
            <div class="col-4">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('animal.ReceipentMother_tagnumber') }}</label>
                <input v-model="state.receipientMotherTagNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.ReceipentMother_tagnumber')" :disabled="isRestrictedRole"> 
              </div>
            </div>
            <div class="col-4">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('animal.ReceipentMother_studbook_number') }}</label>
                <input v-model="state.receipientMotherStudbookNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.ReceipentMother_studbook_number')" :disabled="isRestrictedRole"> 
              </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updatePedigree" class="btn btn-sm bg-gradient-success mr-2 float-end" v-show="!isRestrictedRole">{{ $t('animal.Update_pedigree') }}</button>
        </div>
      </div>
    </div>
    <div id="keeper" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('animal.Breed_keeper') }}</h5>   
        <p class="mb-0 text-sm">{{ $t('animal.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
        <p class="fw-bold">{{ $t('animal.Breeder_details') }}</p>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Breeder') }}</label>
            <template v-if="isRestrictedRole">
              <input type="text" class="form-control form-control-default" :value="state.breederKeepers.find(x => x.id === state.breederId)?.fullname || ''" disabled />
            </template>
            <template v-else> 
              <select id="breederId" v-model="state.breederId" class="form-control form-control-default">
                  <option value="">{{ $t('animal.Select_breeder') }}</option>
                  <option v-for="item in state.breederKeepers" :key="item.id" :value="String(item.id)">
                      {{ item.fullname }}
                  </option>
              </select>
            </template>
          </div>
        </div>        
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('animal.Breeder_name') }} *</label>
            <input v-model="state.breederName" type="text" class="form-control form-control-default" :placeholder="$t('animal.Breeder_name')" :disabled="isRestrictedRole"> 
            <span v-if="vrulesBreederKeeper$.breederName.$error" class="text-sm text-danger">
              {{ vrulesBreederKeeper$.breederName.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-3">
          <p class="fw-bold">{{ $t('animal.Keeper_details') }}</p>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Keeper_details') }}</label>
              <template v-if="isRestrictedRole">
                <input type="text" class="form-control form-control-default" :value="state.breederKeepers.find(x => x.id === state.keeperId)?.fullname || ''" disabled />
              </template>
              <template v-else> 
                <select id="keeperId" v-model="state.keeperId" class="form-control form-control-default">
                    <option value="">{{ $t('animal.Select_keeper') }}</option>
                    <option v-for="item in state.breederKeepers" :key="item.id" :value="String(item.id)">
                        {{ item.fullname }}
                    </option>
                </select>
              </template>
            </div>
          </div>          
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Keeper_name') }}</label>
              <input v-model="state.keeperName" type="text" class="form-control form-control-default" :placeholder="$t('animal.Keeper_name')" :disabled="isRestrictedRole"> 
            </div>
          </div>
        </div> 
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateBreedkeeper" class="btn btn-sm bg-gradient-success mr-2 float-end" v-show="!isRestrictedRole">{{ $t('animal.Update_breeder_keeper') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>    
    <div id="studebook" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('animal.Studebook') }}</h5>   
        <p class="text-sm">{{ $t('animal.Optional_information') }}</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Studebook_section') }}</label>
              <template v-if="isRestrictedRole">
                <input type="text" class="form-control form-control-default" 
                    :value="(() => {
                        const item = state.studebookSections.find(
                            x => x.id === state.studebookSectionId
                        );

                        return item
                            ? `${item.code} (${item.description})`
                            : '';
                    })()"
                disabled />
              </template>
              <template v-else> 
                <select id="studebookSectionId" v-model="state.studebookSectionId" class="form-control form-control-default">
                    <option value="">{{ $t('animal.Select_studebook_section') }}</option>
                    <option v-for="item in state.studebookSections" :key="item.id" :value="item.id">
                        {{ item.code }} ({{ item.description }})
                    </option>
                </select>
              </template>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Studebook_status') }}</label>
              <template v-if="isRestrictedRole">
                <input type="text" class="form-control form-control-default" 
                    :value="(() => {
                        const item = state.studebookStatuses.find(
                            x => x.id === state.studebookStatusId
                        );

                        return item
                            ? `${item.code} (${item.description})`
                            : '';
                    })()"
                disabled />
              </template>
              <template v-else> 
                <select id="studebookStatusId" v-model="state.studebookStatusId" class="form-control form-control-default" :disabled="isRestrictedRole">
                    <option value="">{{ $t('animal.Select_studebook_status') }}</option>
                    <option v-for="item in state.studebookStatuses" :key="item.id" :value="item.id">
                        {{ item.code }} ({{ item.description }})
                    </option>
                </select>
              </template>
            </div>
          </div>
          <div class="col-4">
          </div>
      </div>
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateStudebook" class="btn btn-sm bg-gradient-success mr-2 float-end" v-show="!isRestrictedRole">{{ $t('animal.Update_studebook') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>
    <div id="note" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('animal.Note') }}</h5>   
        <p class="text-sm">{{ $t('animal.Optional_information') }}</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="row">
            <div class="col-12">
              <label class="">{{ $t('animal.Note') }} </label>
              <textarea
                v-model="state.notes"
                class="form-control custom-textarea"
                style="border: 1px solid #ced4da;"
                rows="3"                
              ></textarea>
            </div>        
          </div>          
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateNote" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('animal.Update_note') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>    
    <div id="image" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="row align-items-center justify-content-between">
        <div class="col">
          <div class="card-header pb-3">
            <h5>{{ $t('animal.Image') }}</h5>
            <p class="mb-0 text-sm">
              {{ $t('animal.Optional_information') }} ({{ $t('animal.Upload_animal_image') }})
            </p>
          </div>
        </div>        
      </div>
      <div class="card-body pt-0">
        <div class="row mt-2">
          <div class="col-12">
            <div id="animalImg" class="form-control border dropzone"></div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateImage" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('animal.Upload_image') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div id="removal" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('animal.Removal') }}</h5>   
        <p class="mb-0 text-sm">{{ $t('animal.Optional_information') }}</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Reason') }}</label>
              <template v-if="isRestrictedRole">
                <input type="text" class="form-control form-control-default" 
                    :value="(() => {
                        const item = state.removalReasons.find(
                            x => x.id === state.removalReasonId
                        );

                        return item
                            ? `${item.name} (${item.description})`
                            : '';
                    })()"
                disabled />
              </template>
              <template v-else> 
                <select id="removalReasonId" v-model="state.removalReasonId" class="form-control form-control-default">
                    <option value="">{{ $t('animal.Select_removal_reason') }}</option>
                    <option v-for="item in state.removalReasons" :key="item.id" :value="item.id">
                        {{ item.name }} ({{ item.description }})
                    </option>
                </select>
              </template>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.To_UBN') }}</label>
              <input v-model="state.removalToUbn" type="text" class="form-control form-control-default" :placeholder="$t('animal.To_UBN')" :disabled="isDisabled">               
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Export_country') }}</label>
              <input v-model="state.exportCountry" type="text" class="form-control form-control-default" :placeholder="$t('animal.Export_country')" :disabled="isDisabled">               
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Date') }}</label>
              <input v-model="state.removalDate" type="date" class="form-control form-control-default" :placeholder="$t('animal.Date')" :disabled="isDisabled">               
            </div>
          </div>
                  
        </div> 
        <div class="row mt-4"  v-if="!isDisabled">
          <div class="col-12">
            <button v-on:click="updateRemoval" class="btn btn-sm bg-gradient-success mr-2 float-end" :disabled="isDisabled">{{ $t('animal.Update_removal') }}</button>      
          </div>   
        </div>        
      </div>    
    </div> 
    <div id="studbookworthyness" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('animal.Studbookworthyness') }}</h5>   
        <p class="mb-0 text-sm">{{ $t('animal.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Inspection_date') }} *</label>
              <input v-model="state.inspectionDateSW" type="date" class="form-control form-control-default" :placeholder="$t('animal.Inspection_date')" :disabled="isDisabled">
              <span v-if="vDate$?.inspectionDateSW?.$error" class="text-danger text-sm">
                {{ vDate$.inspectionDateSW.$errors[0].$message }}
              </span>
            </div>
          </div>
        </div>
        <div v-for="(group, rowIndex) in groupedFieldsSW" :key="rowIndex" class="row mt-4">
          <template v-for="(field, colIndex) in group" :key="colIndex">

            <!-- Multiline textarea for 'mult' datatype -->
            <div v-if="field.datatype === 'mult'" class="col-12 mb-3">
              <label class="">{{ field.label }} <span v-if="field.required">*</span></label>
              <textarea v-model="state.model[field.key]" class="form-control custom-textarea" style="border: 1px solid #ced4da;" rows="3" :placeholder="field.label" :disabled="isDisabled"></textarea>
              <span v-if="vDynamicSW$?.[field.key]?.$error" class="text-danger text-sm">
                {{ vDynamicSW$[field.key].$errors[0].$message }}
              </span>
            </div>

            <!-- Date input for 'date' datatype -->
            <div v-else-if="field.datatype === 'date'" class="col-4 mb-3">
              <div class="input-group input-group-static null">
                <label class="">{{ field.label }} <span v-if="field.required">*</span></label>
                <input v-model="state.model[field.key]" type="date" class="form-control form-control-default" :placeholder="field.label" :disabled="isDisabled" />
                <span v-if="vDynamicSW$?.[field.key]?.$error" class="text-danger text-sm">
                  {{ vDynamicSW$[field.key].$errors[0].$message }}
                </span>
              </div>
            </div>

            <!-- Dropdown for refId -->
            <div v-else-if="field.refId" class="col-4 mb-3">
              <div class="input-group input-group-static null">
                <label class="">{{ field.label }} <span v-if="field.required">*</span></label>
                <template v-if="isRestrictedRole">
                  <input type="text" class="form-control form-control-default" 
                      :value="(() => {
                          const item = (referenceTypes[field.refId] || []).find(
                            x => x.id === state.model[field.key]
                          );
                          return item?.name || '';
                      })()"
                  disabled />
                </template>
                <template v-else> 
                  <select v-if="field.datatype === 'ref'" :id="field.key" :name="field.key" v-model="state.model[field.key]" class="form-control form-control-default">
                    <option value="">-- Selecteer {{ field.label }} --</option>
                    <option v-for="ref in referenceTypes[field.refId] || []" :key="ref.id" :value="ref.id">
                      {{ ref.name }}
                    </option>
                  </select>
                  <span v-if="vDynamicSW$?.[field.key]?.$error" class="text-danger text-sm">
                    {{ vDynamicSW$[field.key].$errors[0].$message }}
                  </span>
                </template>
              </div>
            </div>

            <!-- Default text input -->
            <div v-else class="col-4 mb-3">
              <div class="input-group input-group-static null">
                <label>{{ field.label }} <span v-if="field.required">*</span></label>
                <input v-model="state.model[field.key]" type="text" class="form-control form-control-default" :placeholder="field.label" :disabled="isDisabled" />
                <span v-if="vDynamicSW$?.[field.key]?.$error" class="text-danger text-sm">
                  {{ vDynamicSW$[field.key].$errors[0].$message }}
                </span>
              </div>
            </div>
          </template>
        </div>
        <div class="row mt-4" v-if="!isDisabled">
          <div class="col-12">
            <button v-on:click="updateStudbookworthyness" class="btn btn-sm bg-gradient-success mr-2 float-end" :disabled="isDisabled">{{ $t('animal.Update_studbookworthyness') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div id="exteriorpoints" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('animal.Exterior_points') }}</h5>   
        <p class="mb-0 text-sm">{{ $t('animal.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Inspection_date') }} *</label>
              <input v-model="state.inspectionDateEP" type="date" class="form-control form-control-default" :placeholder="$t('animal.Inspection_date')" :disabled="isDisabled">
              <span v-if="vDate$?.inspectionDateEP?.$error" class="text-danger text-sm">
                {{ vDate$.inspectionDateEP.$errors[0].$message }}
              </span>
            </div>
          </div>          
        </div>        
        <div v-for="(group, rowIndex) in groupedFieldsEP" :key="rowIndex" class="row mt-4">
          <template v-for="(field, colIndex) in group" :key="colIndex">

            <!-- Multiline textarea for 'mult' datatype -->
            <div v-if="field.datatype === 'mult'" class="col-12 mb-3">
              <label>{{ field.label }} <span v-if="field.required">*</span></label>
              <textarea v-model="state.model[field.key]" class="form-control custom-textarea" style="border: 1px solid #ced4da;" rows="3" :placeholder="field.label" :disabled="isDisabled"></textarea>
              <span v-if="vDynamicEP$?.[field.key]?.$error" class="text-danger text-sm">
                {{ vDynamicEP$[field.key].$errors[0].$message }}
              </span>
            </div>

            <!-- Date input for 'date' datatype -->
            <div v-else-if="field.datatype === 'date'" class="col-4 mb-3">
              <div class="input-group input-group-static null">
                <label>{{ field.label }} <span v-if="field.required">*</span></label>
                <input v-model="state.model[field.key]" type="date" class="form-control form-control-default" :placeholder="field.label" :disabled="isDisabled" />
                <span v-if="vDynamicEP$?.[field.key]?.$error" class="text-danger text-sm">
                  {{ vDynamicEP$[field.key].$errors[0].$message }}
                </span>
              </div>
            </div>

            <!-- Dropdown for refId -->
            <div v-else-if="field.refId" class="col-4 mb-3">
              <div class="input-group input-group-static null">
                <label>{{ field.label }} <span v-if="field.required">*</span></label>
                <template v-if="isRestrictedRole">
                  <input type="text" class="form-control form-control-default" 
                      :value="(() => {
                          const item = (referenceTypes[field.refId] || []).find(
                            x => x.id === state.model[field.key]
                          );
                          return item?.name || '';
                      })()"
                  disabled />
                </template>
                <template v-else> 
                  <select v-if="field.datatype === 'ref'" :id="field.key" :name="field.key" v-model="state.model[field.key]" class="form-control form-control-default">
                    <option value="">-- Selecteer {{ field.label }} --</option>
                    <option v-for="ref in referenceTypes[field.refId] || []" :key="ref.id" :value="ref.id">
                      {{ ref.name }}
                    </option>
                  </select>                
                  <span v-if="vDynamicEP$?.[field.key]?.$error" class="text-danger text-sm">
                    {{ vDynamicEP$[field.key].$errors[0].$message }}
                  </span>
                </template>
              </div>
            </div>

            <!-- Default text input -->
            <div v-else class="col-4 mb-3">
              <div class="input-group input-group-static null">
                <label>{{ field.label }} <span v-if="field.required">*</span></label>
                <input v-model="state.model[field.key]" type="text" class="form-control form-control-default" :placeholder="field.label" :disabled="isDisabled" />
                <span v-if="vDynamicEP$?.[field.key]?.$error" class="text-danger text-sm">
                  {{ vDynamicEP$[field.key].$errors[0].$message }}
                </span>
              </div>
            </div>
          </template>
        </div>
        <div class="row mt-4" v-if="!isDisabled">
          <div class="col-12">
            <button v-on:click="updateExteriorPoint" class="btn btn-sm bg-gradient-success mr-2 float-end" :disabled="isDisabled">{{ $t('animal.Update_exterior_point') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>     
    <!-- Lightbox -->
    <div v-if="lightboxVisible" class="lightbox-overlay" @click.self="closeLightbox">
      
      <!-- Close Button -->
      <button class="lightbox-close" @click="closeLightbox">×</button>

      <!-- Previous -->
      <button v-if="lightboxImages.length > 1" class="lightbox-nav left" @click.stop="prevImage">
        ❮
      </button>

      <!-- Image -->
      <div class="lightbox-content">
        <img :src="lightboxImages[lightboxIndex]" class="lightbox-image" />
      </div>

      <!-- Next -->
      <button v-if="lightboxImages.length > 1" class="lightbox-nav right" @click.stop="nextImage">
        ❯
      </button>

    </div>
  </template>
  
  <script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import Dropzone from "dropzone";
  import axios from 'axios'
  import { useVuelidate } from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed, nextTick, ref, onMounted, getCurrentInstance  } from 'vue'  
  import { useI18n } from 'vue-i18n'
  import Choices from 'choices.js';
  import { useStore } from 'vuex'
  import { useRouter, useRoute } from 'vue-router'

  export default {
    name: "AnimalDetailItem",
    data() {
      return {
        lightboxVisible: false,
        lightboxImages: [],
        lightboxIndex: 0
      }
    },
    setup() {
        
      const { t } = useI18n()
            
      const state = reactive ({
        animal: [],
        breeds: [],        
        animalGenoTypes: [],
        animalGenoTypes2: [],
        countryCodes: [],
        animalGenders: [],
        animalColours: [],
        origins: [],
        breederKeepers: [],
        studebookSections: [],
        studebookStatuses: [],
        removalReasons: [],
        animalImages: [],
        selectedFiles: [],
        gets: [],

        id: '',
        call: '',

        //Aninal Info
        ubnId: '',        
        associationId: '',
        associationName: '',
        breedId: '',
        genoTypeId: '',
        genoTypeId2: '',
        animalTypeId: '',
        tagNumber: '',        
        animalNumber: '',
        studbookNumber: '',
        birthDate: null,
        countryOfBirthId: '',
        genderId: '',
        colorId: '',
        casterated: false,
        inbreedFactor: null,

        //Arrival
        countryCodeId: '',
        arrivalDate: null,
        originId: '',        
        arrivalFromUbn: '',
        arrivalFromUbnName: '',

        //Pedigree
        fatherCountryCodeId: '',
        fatherTagNumber: '',
        fatherStudbookNumber: '',
        motherCountryCodeId: '',
        motherTagNumber: '',
        motherStudbookNumber: '',
        receipientMotherCountryCodeId: '',
        receipientMotherTagNumber: '',
        receipientMotherStudbookNumber: '',

        //BreedKeeper
        ////Breeder
        breederId: '',        
        breederName: '',  //Not null
        keeperId: '',        
        keeperName: '',

        //Studebook
        studebookSectionId: '',
        studebookStatusId: '',
        
        notes: '',

        //Removal
        removalDate: null, 
        removalReasonId: '',
        removalToUbn: '',
        exportCountry: '',

        deleteLocation: false,
        inspectionDateSW: null,
        inspectionDateEP: null,
        model: {},
    })
    
    const groupedFieldsSW = ref([]);    
    const groupedFieldsEP = ref([]);
    const dropdownOptionsMap = reactive({});
    const referenceTypes = reactive({});

    function generateDynamicRules(groupedFields) {
      const rules = {};

      groupedFields.value.flat().forEach(field => {
        const fieldRules = {};

        if (field.required) {
          fieldRules.required = helpers.withMessage(t('common.Required'), required);
        }

        if (field.datatype === 'int') {
          fieldRules.integerOnly = integerOnly;
        }

        if (field.datatype === 'dec') {
          fieldRules.decimalOnly = decimalOnly;
        }

        if (Object.keys(fieldRules).length > 0) {
          rules[field.key] = fieldRules;
        }
      });

      return rules;
    }

    async function fetchGroupedFields() {
      try {        
        await fetchAndBuildGroupedFields("KEURSTW", proxy.$route.params.id, groupedFieldsSW, dynamicRulesSW, "SW_");
        await fetchAndBuildGroupedFields("KEURPNT", proxy.$route.params.id, groupedFieldsEP, dynamicRulesEP, "EP_");

        await initializeDynamicDropdowns(groupedFieldsSW);
        await initializeDynamicDropdowns(groupedFieldsEP);
      } catch (error) {
        console.error("Error loading grouped fields:", error);
      }
    }

    async function fetchAndBuildGroupedFields(groupCode, animalId, groupedRef, dynamicRulesRef = null, keyPrefix = '') {
      const response = await axios.get("animal/getbygroup", {
        params: { groupCode, animalId },
      });
        
      const attributes = response.data.data || [];
      const rows = [];

      for (let i = 0; i < attributes.length; i += 3) {
        const row = attributes.slice(i, i + 3).map(attr => {
          const prefixedKey = `${keyPrefix}${attr.attributeCode}`;
          return {
            key: prefixedKey,
            aattrId: attr.id,
            attrId: attr.attributeId,
            label: attr.attribute1,
            refId: attr.referenceTypeId,
            refName: attr.referenceTypeName,
            datatype: attr.datatype,
            required: attr.required,
            originalKey: attr.attributeCode,
            date: attr.date,
            attInt: attr.attInt,
            attDec: attr.attDec,
            attChar: attr.attChar,
            attDate: attr.attDate,
            attRef: attr.attRef
          };
        });
        rows.push(row);
      }
      
      groupedRef.value = rows;

      // store inspection date from first attribute if present
      if (attributes.length > 0 && attributes[0].date) {
        const rawDate = attributes[0].date;
        //console.log('Raw Date:', rawDate);
        
        const formattedDate = rawDate.split('T')[0];
        //console.log('Formatted Date:', formattedDate);

        if (groupCode === 'KEURPNT') {          
          state.inspectionDateEP = (formattedDate === '0001-01-01') ? '' : formattedDate;
        } else if (groupCode === 'KEURSTW') {          
          state.inspectionDateSW = (formattedDate === '0001-01-01') ? '' : formattedDate;
        }
      }

      rows.flat().forEach(field => {
        if (!(field.key in state.model) || state.model[field.key] === '') {
          let value = '';

          switch (field.datatype) {
            case 'int':
              value = field.attInt ?? '';
              break;
            case 'dec':
              value = field.attDec ?? '';
              break;
            case 'date':
              value = field.attDate ? field.attDate.split('T')[0] : ''; // Format date
              break;
            case 'mult':
            case 'char':
              value = field.attChar ?? '';
              break;
            case 'ref':
              value = field.attRef ?? '';
              break;
          }

          state.model[field.key] = value;
        }

        if (dynamicRulesRef) {
          const fieldRules = {};
          if (field.required) {
            fieldRules.required = helpers.withMessage(t('common.Required'), required);
          }
          if (field.datatype === 'int') {
            fieldRules.integerOnly = integerOnly;
          }
          if (field.datatype === 'dec') {
            fieldRules.decimalOnly = decimalOnly;
          }

          if (Object.keys(fieldRules).length > 0) {
            dynamicRulesRef.value[field.key] = fieldRules;
          }
        }
      });
    }

    function getDropdownOptionsSync(refId, refName) {
      getDropdownOptions(refId, refName); 
      return dropdownOptionsMap[refName] || [];
    }

    async function getDropdownOptions(refId, refName) {
      if (!refId || !refName) return [];

      if (referenceTypes[refId]) {
        return referenceTypes[refId];
      }

      try {
        const response = await axios.get("reference/getreference", {
          params: { referenceTypeId: refId },
        });

        if (response.data.success && Array.isArray(response.data.data)) {
          referenceTypes[refId] = response.data.data;
          return referenceTypes[refId];
        }
      } catch (err) {
        console.error(`Failed to fetch options for ${refName}:`, err);
      }

      return [];
    }  

    const dropdownInstances = reactive({});

    function initializeDynamicChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
      const element = document.getElementById(id);
      if (!element || element.tagName !== "SELECT") {
        console.error(`Choices: Invalid or missing select element with ID "${id}".`);
        return;
      }

      if (dropdownInstances[instanceKey]) {
        dropdownInstances[instanceKey].destroy();
      }

      dropdownInstances[instanceKey] = new Choices(element, {
        searchEnabled: true,
        itemSelectText: '',
        shouldSort: false,
        placeholder: true,
      });

      if (this.isRestrictedRole) {
          this[instanceKey].disable();
      }

      if (selectedValue) {
        const optionExists = dataList.some(item => item.id === selectedValue);
        dropdownInstances[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
      }
    }

    async function initializeDynamicDropdowns(groupedFields) {
      await nextTick(); // ensure DOM is rendered

      const flatFields = groupedFields.value.flat();

      for (const field of flatFields) {
        if (!field.refId) continue;

        const options = await getDropdownOptions(field.refId, field.refName);
        const selectedValue = state.model[field.key];

        initializeDynamicChoicesDropdown({
          id: field.key, // ensure your `<select>` has :id="field.key"
          dataList: options,
          selectedValue,
          instanceKey: `choices_${field.key}`
        });
      }
    }

    onMounted(async () => {      
      await fetchGroupedFields();
    });

    const integerOnly = helpers.withMessage(
      t('common.Integer_only'),
      value => {
        if (value === '' || value === null || value === undefined) return true; // allow empty
        return /^[0-9]+$/.test(value); // only allow integers
      }
    )

    const decimalOnly = helpers.withMessage(
      t('common.Decimal_only_max_2_places'),
      value => {
        if (value === '' || value === null || value === undefined) return true; // allow empty
        return /^-?\d+(\.\d{1,2})?$/.test(value); // allows optional - sign, integer part, and up to 2 decimal digits
      }
    );


    const route = useRoute()
    
    // ---- Async studbook validator (with caching + abort) ----
    const existsCache = new Map()
    let inFlightCtrl = null

    const checkStudbookExists = async (value) => {
      const key = String(value || '').trim().toUpperCase()

      // empty input → let required/format handle it
      if (!key) return true

      // if association not set yet, don't block
      if (!state.associationId) return true

      if (existsCache.has(key)) return existsCache.get(key)

      if (inFlightCtrl) inFlightCtrl.abort()
      inFlightCtrl = new AbortController()

      try {
        const { data } = await axios.get('animal/studbookexists', {
          params: {
            associationId: state.associationId,              
            studbookNumber: key,
            animalId: state.id || route.params.id
          },
          signal: inFlightCtrl.signal
        })

        const exists = !!data?.exists   // true if DB has it (excluding this animal)
        existsCache.set(key, exists)
        return exists
      } catch (err) {
        if (axios.isCancel?.(err)) return true  // don't block on cancel
        console.error('Studbook validation failed:', err)
        return true                               // don't block on network errors
      }
    }

    const rulesAnimalDetails = computed(() => ({
      studbookNumber: {
        required: helpers.withMessage(t('common.Required'), required),
        format: helpers.withMessage(
          t('common.Only_letters_numbers_and_hyphens_are_allowed'),
          (v) => /^[A-Za-z0-9-]+$/.test(String(v || '').trim())
        ),
        unique: helpers.withMessage(
          t('common.Studbook_number_already_exists'),
          helpers.withAsync(async (v) => {
            const exists = await checkStudbookExists(v)
            return !exists
          })
        )
      },
      breedId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('animal.Select_breed'), value => value !== '')
      },      
      countryOfBirthId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('animal.Select_country_of_birth'), value => value !== '')
      },
      genderId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('animal.Select_gender'), value => value !== '')
      },      
      birthDate: { required: helpers.withMessage(t('common.Required'), required) },
      inbreedFactor: { decimalOnly }
    }))

    const rulesBreederKeeper = computed(() => ({      
      breederName: { required: helpers.withMessage(t('common.Required'), required) },
    }))
    
    const rulesDateValidation = computed(() => ({
      inspectionDateSW: {
        required: helpers.withMessage(t('common.Required'), required)
      },
      inspectionDateEP: {
        required: helpers.withMessage(t('common.Required'), required)
      }
    }));
    
    const userRoleName = computed(() => store.state.user?.roleName)

    const isRestrictedRole = computed(() => 
      userRoleName.value === "Keeper" || userRoleName.value === "Inspector"
    );

    const isRestrictedKeep = computed(() => 
      userRoleName.value === "Keeper"
    );

    const isRestrictedInsp = computed(() => 
      userRoleName.value === "Inspecter"
    );


    const arrivalFromUbnDisplay = computed({
      get() {
        return state.arrivalFromUbnName
      },
      set(value) {        
        state.arrivalFromUbnName = value
      }
    });

    const vAnimalDetails$ = useVuelidate(rulesAnimalDetails, state, { $autoDirty: true, $lazy: true })
    const vrulesBreederKeeper$ = useVuelidate(rulesBreederKeeper, state)
    const vDate$ = useVuelidate(rulesDateValidation, computed(() => state));

    const dynamicRulesSW = computed(() => generateDynamicRules(groupedFieldsSW));
    const vDynamicSW$ = useVuelidate(dynamicRulesSW, computed(() => state.model));

    const dynamicRulesEP = computed(() => generateDynamicRules(groupedFieldsEP));
    const vDynamicEP$ = useVuelidate(dynamicRulesEP, computed(() => state.model));

    const store = useStore();
    const router = useRouter();
    const { proxy } = getCurrentInstance();

    const updateExteriorPoint = async () => {
      try {
        store.commit('setShowLoading', true);

        const isValid = await vDynamicEP$.value.$validate();
        const isDateValid = await vDate$.value.inspectionDateEP.$validate();        

        if (isValid && isDateValid) {          
          const attributes = groupedFieldsEP.value
          .flat()
          .map(field => ({
            animalattributeId: field.aattrId,
            attributeId: field.attrId,
            attributeValue: String(state.model[field.key] ?? ""),
            attributeDataType: field.datatype
          }));

          const payload = {
              id: state.id,
              date: state.inspectionDateEP || null,
              attributes
          };
          const response = await axios.post('animal/addanimalinfo', payload);

          if (response.data.success) {
            proxy.$showSuccess('errors.Success_exteriorpoint_updated_successfully');
            router.push({ path: `/animal/edit/${state.id}` });
          } else {
            proxy.$showError('errors.Contact_system_admin');
          }
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || t('errors.Something_went_wrong');
        proxy.$showError(`${t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {
        store.commit('setShowLoading', false);
      }
    };
    
    const updateStudbookworthyness = async () => {
      try {
        store.commit('setShowLoading', true);
        
        const isValid = await vDynamicSW$.value.$validate();
        const isDateValid = await vDate$.value.inspectionDateSW.$validate();

        if (isValid && isDateValid) {
          const attributes = groupedFieldsSW.value
          .flat()
          .map(field => ({
            animalattributeId: field.aattrId,
            attributeId: field.attrId,
            attributeValue: String(state.model[field.key] ?? ""),
            attributeDataType: field.datatype
          }));

          const payload = {
            id: state.id,
            date: state.inspectionDateSW || null,
            attributes
          };
          const response = await axios.post('animal/addanimalinfo', payload);

          if (response.data.success) {
            proxy.$showSuccess('errors.Success_studbookworthyness_updated_successfully');
            router.push({ path: `/animal/edit/${state.id}` });
          } else {
            proxy.$showError('errors.Contact_system_admin');
          }
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || t('errors.Something_went_wrong');
        proxy.$showError(`${t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {
        store.commit('setShowLoading', false);
      }
    };
    return {
        state,        
        vAnimalDetails$,
        vrulesBreederKeeper$,
        vDate$,
        vDynamicSW$,
        vDynamicEP$,
        groupedFieldsSW,
        groupedFieldsEP,
        dynamicRulesSW,
        dynamicRulesEP,
        isRestrictedRole,
        isRestrictedKeep,
        isRestrictedInsp,
        generateDynamicRules,
        fetchGroupedFields,
        getDropdownOptionsSync,
        updateExteriorPoint,
        updateStudbookworthyness,
        initializeDynamicChoicesDropdown,
        initializeDynamicDropdowns,
        arrivalFromUbnDisplay,
        referenceTypes
      }
  },  
    components: {
      MaterialSwitch,
    },
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        isDisabled() {
          return this.userRoleName === 'Keeper';
        }
    },
    async mounted() {  
      this.id = this.$route.params.id;
      this.call = this.$route.query.call;
      
      try {
            this.$store.commit('setShowLoading', true);
            
            await this.fetchAnimalData(this.$route.params.id, this.$route.query.call);

            const referenceTypes = {              
              animalGenoTypes: "31288ca2-5fed-434b-8d25-cfda6191fbd1",
              animalGenoTypes2: "d84046a2-769f-4882-a3cb-9cf6879192d2",
              countryCodes: "8e7cedbf-891f-481e-bb84-07efd0aa8188",
              animalGenders: "9a1d69fe-c91f-4634-80cb-9f56db8d2a46",
              animalColours: "6d58593a-62f2-4fed-93b9-84eaabbbf47a",
              origins: "9acd2adf-fdce-4749-b519-cd547cd3d1dc",
              removalReasons: "05362685-8365-40f2-9cd6-5d65a3ab0fd0"
            };

            const fetchPromises = [
              this.fetchAnimalImages(),              
              this.fetchAndSetData(`breed/getbyassociation?associationId=${this.state.associationId}`, "breeds"),              
              this.fetchAndSetData("user/getuser?role=keeper", "breederKeepers"),
              this.fetchAndSetData(`studebookstatus/getbyassociation?associationId=${this.state.associationId}`, "studebookStatuses"),
              this.fetchAndSetData(`studebooksection/getbyassociation?associationId=${this.state.associationId}`, "studebookSections")
            ];            

            for (const [key, typeId] of Object.entries(referenceTypes)) {
              fetchPromises.push(this.fetchAndSetData(`reference/getreference?referenceTypeId=${typeId}`, key));
            }

            await Promise.all(fetchPromises);

            await nextTick();

            const dropdownConfigs = [
              { id: "breedId", key: "breeds", selected: this.state.breedId, inst: "choicesInstanceBreed" },              
              { id: "genoTypeId", key: "animalGenoTypes", selected: this.state.genoTypeId, inst: "choicesInstanceGenoType" },
              { id: "genoTypeId2", key: "animalGenoTypes2", selected: this.state.genoTypeId2, inst: "choicesInstanceGenoType2" },
              { id: "originId", key: "origins", selected: this.state.originId, inst: "choicesInstanceOrigin" },
              { id: "countryOfBirthId", key: "countryCodes", selected: this.state.countryCodeId, inst: "choicesInstanceBirthCountryCode" },
              { id: "countryCodeId", key: "countryCodes", selected: this.state.countryCodeId, inst: "choicesInstanceCountryCode" },
              { id: "fatherCountryCodeId", key: "countryCodes", selected: this.state.fatherCountryCodeId, inst: "choicesInstanceFatherCountryCode" },
              { id: "motherCountryCodeId", key: "countryCodes", selected: this.state.motherCountryCodeId, inst: "choicesInstanceMotherCountryCode" },
              { id: "receipientMotherCountryCodeId", key: "countryCodes", selected: this.state.receipientMotherCountryCodeId, inst: "choicesInstanceRecepientMotherCountryCode" },
              { id: "genderId", key: "animalGenders", selected: this.state.genderId, inst: "choicesInstanceGender" },
              { id: "colorId", key: "animalColours", selected: this.state.colorId, inst: "choicesInstanceColor" },
              { id: "breederId", key: "breederKeepers", selected: this.state.breederId, inst: "choicesInstanceBreeder" },
              { id: "keeperId", key: "breederKeepers", selected: this.state.keeperId, inst: "choicesInstanceKeeper" },
              { id: "studebookStatusId", key: "studebookStatuses", selected: this.state.studebookStatusId, inst: "choicesInstanceStudebookStatus" },
              { id: "studebookSectionId", key: "studebookSections", selected: this.state.studebookSectionId, inst: "choicesInstanceStudebookSection" },
              { id: "removalReasonId", key: "removalReasons", selected: this.state.removalReasonId, inst: "choicesInstanceRemovalreasonSection" }
            ];

            dropdownConfigs.forEach(cfg => {
              this.initializeChoicesDropdown({
                id: cfg.id,
                dataList: this.state[cfg.key],
                selectedValue: cfg.selected,
                instanceKey: cfg.inst
              });
            });
            
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }      
    },
    methods: {        
      async fetchAndSetData(endpoint, property) {
        try {
          const response = await axios.get(endpoint);
          const result = response.data;

          if (result.success) {
            if (property === 'breederKeepers') {
              this.state[property] = result.data.userList;
            } else if (property === 'ubns') {
              this.state[property] = result.data.locationList;
            } else {
              this.state[property] = result.data;
            }
          } else {
            this.$showError('errors.Contact_system_admin');
          }          
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
      },
      initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
        const element = document.getElementById(id);
        if (!element || element.tagName !== "SELECT") {
            console.error(`Choices: Invalid or missing select element with ID "${id}".`);
            return;
        }

        // Destroy previous instance if it exists
        if (this[instanceKey]) {
            this[instanceKey].destroy();
        }

        // Initialize new Choices instance
        this[instanceKey] = new Choices(element, {
            searchEnabled: true,
            itemSelectText: '',
            shouldSort: false,
            placeholder: true,
        });

        // Set selected value if it exists in list
        if (selectedValue) {
            const optionExists = dataList.some(item => item.id === selectedValue);
            this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
        }
      },
      async fetchAnimalData(animalId, call) {
        try {
            this.$store.commit('setShowLoading', true);

            let response;
            if (call == 'pedigree') {
              response = await axios.get(`animal/getdetailsinpedigree/${animalId}`);
            } else {
              response = await axios.get(`animal/${animalId}`);
            }

            this.gets = response.data;
            
            if (this.gets.success) {
                this.state.animal = this.gets.data;

                this.state.id = this.state.animal.id;
                this.state.ubnId = this.state.animal.ubnid;
                this.state.ubn = this.state.animal.ubn;
                this.state.name = this.state.animal.name;

                this.state.associationId = this.state.animal.associationId;
                this.state.associationName = this.state.animal.associationName;
                this.state.breedId = this.state.animal.breedId;
                this.state.genoTypeId = this.state.animal.genoTypeId;
                this.state.genoTypeId2 = this.state.animal.genoTypeId2;
                this.state.animalTypeId = this.state.animal.animalTypeId;                
                this.state.tagNumber = this.state.animal.tagNumber;
                this.state.animalNumber = this.state.animal.animalNumber;
                this.state.studbookNumber = this.state.animal.studbookNumber;
                this.state.birthDate = this.state.animal.birthDate;
                this.state.countryOfBirthId = this.state.animal.countryCodeId;
                this.state.genderId = this.state.animal.genderId;
                this.state.colorId = this.state.animal.colorId;
                this.state.casterated = this.state.animal.casterated;
                this.state.inbreedFactor = this.state.animal.inbreedFactor;

                //Arrival
                this.state.countryCodeId = this.state.animal.countryCodeId;
                this.state.arrivalDate = this.state.animal.arrivalDate;
                this.state.originId = this.state.animal.originId;        
                this.state.arrivalFromUbn = this.state.animal.arrivalFromUbn;
                this.state.arrivalFromUbnName = this.state.animal.arrivalFromUbnName;

                //Pedigree
                this.state.fatherCountryCodeId = this.state.animal.fatherCountryCodeId;
                this.state.fatherTagNumber = this.state.animal.fatherTagNumber;
                this.state.fatherStudbookNumber = this.state.animal.fatherStudbookNumber;
                this.state.motherCountryCodeId = this.state.animal.motherCountryCodeId;
                this.state.motherTagNumber = this.state.animal.motherTagNumber;
                this.state.motherStudbookNumber = this.state.animal.motherStudbookNumber;
                this.state.receipientMotherCountryCodeId = this.state.animal.receipientMotherCountryCodeId;
                this.state.receipientMotherTagNumber = this.state.animal.receipientMotherTagNumber;
                this.state.receipientMotherStudbookNumber = this.state.animal.receipientMotherStudbookNumber;

                //BreedKeeper
                ////Breeder
                this.state.breederId = this.state.animal.breederId;                
                this.state.breederName = this.state.animal.breederName;  //Not null
                this.state.keeperId = this.state.animal.keeperId;                
                this.state.keeperName = this.state.animal.keeperName;

                //Studebook
                this.state.studebookSectionId = this.state.animal.studebookSectionId;
                this.state.studebookStatusId = this.state.animal.studebookStatusId;
                
                this.state.notes = this.state.animal.notes;

                //Removal
                this.state.removalDate = this.state.animal.removalDate;
                this.state.removalReasonId = this.state.animal.removalReasonId;
                this.state.removalToUbn = this.state.animal.removalToUbn;
                this.state.exportCountry = this.state.animal.exportCountry;
                
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async fetchAnimalImages() {
        this.$store.commit('setShowLoading', true);
        try {
          const fileType = 'AnimalImage';
          const response = await axios.get(`animal/getfiles/${this.state.id}`, {
            params: { fileType }
          });

          const files = response.data.data ?? [];

          this.state.animalImages = files.map(img => ({
            id: img.id,
            url: img.url,
            fileName: img.fileName,
            size: img.fileSize
          }));

          this.initializeDropzoneImage();
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      initializeDropzoneImage() {
        const vm = this;

        // Destroy previous instance if exists
        if (vm.dropzoneAnimalImageInstance) {
          vm.dropzoneAnimalImageInstance.destroy();
          document.querySelector("#animalImg").innerHTML = "";
        }

        vm.dropzoneAnimalImageInstance = new Dropzone("#animalImg", {
          url: "/file-upload", // not used (manual upload)
          maxFiles: 5,
          maxFilesize: 5,
          acceptedFiles: "image/*",
          addRemoveLinks: true,
          autoProcessQueue: false,
          dictDefaultMessage: "Sleep bestanden hierheen om te uploaden",
          dictRemoveFile: "Verwijderen",

          init: function () {
            const dz = this;

            // Load existing images
            vm.state.animalImages.forEach((image, index) => {

              const mockFile = {
                name: image.fileName,
                size: image.size || 123456,
                serverId: image.id,
                isExisting: true
              };

              dz.emit("addedfile", mockFile);
              dz.emit("thumbnail", mockFile, image.url);
              dz.emit("complete", mockFile);

              // Lightbox click for existing images
              const imageElement =
                mockFile.previewElement.querySelector(".dz-image");

              if (imageElement) {
                imageElement.addEventListener("click", function (e) {
                  e.stopPropagation();
                  vm.openLightbox(index);
                });
              }
            });

            // Handle newly added files
            dz.on("addedfile", function (file) {

              if (!file.serverId) {
                vm.state.selectedFiles.push(file);
              }

              const imageElement =
                file.previewElement?.querySelector(".dz-image");

              if (imageElement) {
                imageElement.addEventListener("click", function (e) {
                  e.stopPropagation();

                  // Open preview for new image
                  if (file.dataURL) {
                    vm.lightboxImages = [file.dataURL];
                    vm.lightboxIndex = 0;
                    vm.lightboxVisible = true;
                  }
                });
              }
            });

            // Handle remove (server + local)
            dz.on("removedfile", function (file) {

              if (file.serverId) {
                // Existing image → delete from server
                axios.delete(`animal/deletefile/${file.serverId}`)
                  .then(() => {
                    vm.state.animalImages =
                      vm.state.animalImages.filter(img => img.id !== file.serverId);
                  })
                  .catch(err => {
                    console.error("Error deleting image:", err);
                  });

              } else {
                // New file → remove from selectedFiles
                vm.state.selectedFiles =
                  vm.state.selectedFiles.filter(f => f !== file);
              }
            });

          }
        });
      },      
      async updateAnimalInfo() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.vAnimalDetails$.$validate();
            //console.log(this.vAnimalDetails$.$error);
            
            if(!this.vAnimalDetails$.$error) {     
                const response = await axios.put('animal/updateanimalinfo', {
                  "id": this.state.id,
                  "breedId": this.state.breedId,
                  "genoTypeId": this.state.genoTypeId,
                  "genoTypeId2": this.state.genoTypeId2,                  
                  "name": this.state.name,                  
                  "tagNumber": this.state.tagNumber,
                  "animalNumber": this.state.animalNumber,
                  "studbookNumber": this.state.studbookNumber,
                  "birthDate": this.state.birthDate,
                  "countryOfBirthId": this.state.countryOfBirthId,
                  "genderId": this.state.genderId,
                  "colorId": this.state.colorId,
                  "inbreedFactor": this.state.inbreedFactor,
                  "casterated": this.state.casterated
                  });
                this.gets = response.data;

                if (this.gets.success) {
                  
                  this.$showSuccess('errors.Success_animalinfo_updated_successfully');
                  
                  this.$router.push({ path: `/animal/edit/${this.state.id}` }).then(() => {
                    this.fetchAnimalData(this.state.id); // Trigger data refresh or any required action
                  });
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateArrival() {   
        try {
            this.$store.commit('setShowLoading', true);

            const response = await axios.put('animal/updatearrival', {
              "id": this.state.id,
              "arrivalDate": this.state.arrivalDate || null,
              "arrivalFromUbn": this.state.arrivalFromUbn,
              "originId": this.state.originId,
              "countryCodeId": this.state.countryCodeId
            });
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_arrival_updated_successfully');
              
              this.$router.push({ path: `/animal/edit/${this.state.id}` }).then(() => {
                this.fetchAnimalData(this.state.id); // Trigger data refresh or any required action
              });
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updatePedigree() {   
        try {
            this.$store.commit('setShowLoading', true);
                        
            const response = await axios.put('animal/updatepedigree', {
              "id": this.state.id,
              "fatherCountryCodeId": this.state.fatherCountryCodeId,
              "fatherTagNumber": this.state.fatherTagNumber,
              "fatherStudbookNumber": this.state.fatherStudbookNumber,
              "motherCountryCodeId": this.state.motherCountryCodeId,
              "motherTagNumber": this.state.motherTagNumber,
              "motherStudbookNumber": this.state.motherStudbookNumber,
              "receipientMotherCountryCodeId": this.state.receipientMotherCountryCodeId,
              "receipientMotherTagNumber": this.state.receipientMotherTagNumber,
              "receipientMotherStudbookNumber": this.state.receipientMotherStudbookNumber
            });
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_pedigree_updated_successfully');
              
              this.$router.push({ path: `/animal/edit/${this.state.id}` }).then(() => {
                this.fetchAnimalData(this.state.id); // Trigger data refresh or any required action
              });
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateBreedkeeper() {
        try {
          this.$store.commit('setShowLoading', true);

          this.vrulesBreederKeeper$.$validate();
          //console.log(this.vrulesBreederKeeper$.$error);

          const response = await axios.put('animal/updatebreederkeeper', {
              "id": this.state.id,
              "breederId": this.state.breederId,              
              "breederName": this.state.breederName,
              "keeperId": this.state.keeperId,              
              "keeperName": this.state.keeperName
          });
          this.gets = response.data;

          if (this.gets.success) {
            
            this.$showSuccess('errors.Success_breeder_keeper_updated_successfully');
            
            this.$router.push({ path: `/animal/edit/${this.state.id}` }).then(() => {
              this.fetchAnimalData(this.state.id);
            });
          } else {
            this.$showError('errors.Contact_system_admin');
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateStudebook() {
        try {
          this.$store.commit('setShowLoading', true);

          const response = await axios.put('animal/updatestudebook', {
              "id": this.state.id,
              "studebookSectionId": this.state.studebookSectionId,
              "studebookStatusId": this.state.studebookStatusId              
          });
          this.gets = response.data;

          if (this.gets.success) {

            this.$showSuccess('errors.Success_studebook_updated_successfully');
            
            this.$router.push({ path: `/animal/edit/${this.state.id}` }).then(() => {
              this.fetchAnimalData(this.state.id);
            });
          } else {
            this.$showError('errors.Contact_system_admin');
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateNote() {
        try {
          this.$store.commit('setShowLoading', true);

          const response = await axios.put('animal/updatenote', {
              "id": this.state.id,
              "notes": this.state.notes
          });
          this.gets = response.data;

          if (this.gets.success) {

            this.$showSuccess('errors.Success_note_updated_successfully');
            
            this.$router.push({ path: `/animal/edit/${this.state.id}` }).then(() => {
              this.fetchAnimalData(this.state.id);
            });
          } else {
            this.$showError('errors.Contact_system_admin');
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateImage() {        
        if (!this.state.selectedFiles || this.state.selectedFiles.length === 0) {
          this.$showError('errors.No_image_selected_for_upload');
          return;
        }

        const formData = new FormData();
        this.state.selectedFiles.forEach(file => {
          formData.append('files', file); // 'files' as array
        });
        formData.append('animalId', this.state.id);

        try {
          const response = await axios.post('animal/uploadfiles', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          console.log('Images uploaded successfully:', response.data);
          this.dropzoneAnimalImageInstance.removeAllFiles();
          this.state.selectedFiles = [];

          this.$showSuccess('errors.Success_image_updated_successfully');

          this.$router.push({ path: `/animal/edit/${this.state.id}` }).then(() => {
            this.fetchAnimalImages();
          });

        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
      },     
      async updateRemoval() {
        try {
          this.$store.commit('setShowLoading', true);
          console.log(this.state.removalDate);
          const response = await axios.put('animal/updateremoval', {
              "id": this.state.id,
              "removalDate": this.state.removalDate || null,
              "removalReasonId": this.state.removalReasonId,
              "removalToUbn": this.state.removalToUbn,
              "exportCountry": this.state.exportCountry
          });
          this.gets = response.data;

          if (this.gets.success) {

            this.$showSuccess('errors.Success_removal_updated_successfully');
            
            this.$router.push({ path: `/animal/edit/${this.state.id}` }).then(() => {
              this.fetchAnimalData(this.state.id);
            });
          } else {
            this.$showError('errors.Contact_system_admin');
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateExteriorPoint1() {
        try {
          this.$store.commit('setShowLoading', true);

          console.log('Validation object:', this.vDynamicEP$.value);
          console.log('Model:', this.state.model);
          console.log('Rules:', this.dynamicRulesEP.value);

          const isValid = await this.vDynamicEP$.value.$validate();
          console.log(isValid);
          if (isValid) {
            const response = await axios.put('animal/updateanimalinfo', {
              id: this.state.id,
              date: this.state.inspectionDateEP || null
            });

            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_exteriorpoint_updated_successfully');

              this.$router.push({ path: `/animal/edit/${this.state.id}` }).then(() => {
                this.fetchAnimalData(this.state.id);
              });
            } else {
              this.$showError('errors.Contact_system_admin');
            }
          }

        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateStudbookworthyness1() {

      },
      handleFileUpload(event, fieldName) {
        const file = event.target.files[0];
        if (file && fieldName === 'toilerCertificateFile') {
          this.state.toilerCertificateFile = file;
          this.state.toilerCertificateFilePath = file.name;
        } else if (file && fieldName === 'scrapieCertificateFile') {
          this.state.scrapieCertificateFile = file;
          this.state.scrapieCertificateFilePath = file.name;
        }
      },
      confirmDelete() {
        this.state.deleteLocation = !this.state.deleteLocation;
      },      
      deleteLocation() {
        if (this.state.deleteLocation) {
          this.deleteLocation1(this.state.id)
        }
      },                  
      async deleteLocation1(id) {   
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.delete("animal/" + id);
            this.gets = response.data;

            if (this.gets.success) {

              this.$showSuccess('errors.Success_location_deleted_successfully');
              
              this.$router.push('/location');                
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {          
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }         
      },
      openLightbox(startIndex = 0) {
        this.lightboxImages = this.state.animalImages.map(img => img.url);
        this.lightboxIndex = startIndex;
        this.lightboxVisible = true;

        document.addEventListener("keydown", this.handleKeydown);
      },

      closeLightbox() {
        this.lightboxVisible = false;
        document.removeEventListener("keydown", this.handleKeydown);
      },

      nextImage() {
        this.lightboxIndex =
          (this.lightboxIndex + 1) % this.lightboxImages.length;
      },

      prevImage() {
        this.lightboxIndex =
          (this.lightboxIndex - 1 + this.lightboxImages.length) %
          this.lightboxImages.length;
      },

      handleKeydown(e) {
        if (!this.lightboxVisible) return;

        if (e.key === "Escape") this.closeLightbox();
        if (e.key === "ArrowRight") this.nextImage();
        if (e.key === "ArrowLeft") this.prevImage();
      }
    }
  };
  </script>
  <style scoped>
  .custom-textarea {
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0.5rem;  
  }

  ::v-deep .dropzone .dz-preview .dz-image  {
    height: 50px !important;
  }

  ::v-deep .dropzone .dz-preview .dz-image img {
    display: block;
    height: 50px !important;
    overflow: hidden;
    object-fit: cover;
    max-height: 50px;
    margin: 0 auto;
  }

  ::v-deep .dz-details,
  ::v-deep .dz-filename,
  ::v-deep .dz-size {
    display: none !important;
  }
  
  ::v-deep .dz-preview {
    vertical-align: bottom !important;
    margin: 0px !important;
  }

  ::v-deep .dz-message {
    display: block !important;
    margin: 5px !important;
  } 

  .lightbox-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.92);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.25s ease;
  }

  .lightbox-content {
    max-width: 90%;
    max-height: 90%;
  }

  .lightbox-image {
    max-width: 100%;
    max-height: 90vh;
    border-radius: 10px;
    box-shadow: 0 0 40px rgba(0,0,0,0.6);
  }

  .lightbox-close {
    position: absolute;
    top: 20px;
    right: 30px;
    font-size: 40px;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
  }

  .lightbox-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 50px;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 10px;
  }

  .lightbox-nav.left {
    left: 30px;
  }

  .lightbox-nav.right {
    right: 30px;
  }

  @keyframes fadeIn {
    from { opacity: 0 }
    to { opacity: 1 }
  }
  </style>